module.exports = __webpack_public_path__ + "img/time.41043044.png";